import type { FormValidationMessages } from '@eliadmin/core/src/hooks/use-form-validation-messages';

import { z } from 'zod';

export const driveSchema = (VM: FormValidationMessages) =>
  z.object({
    custom: z.object({
      name: z.string().min(1, VM.CANT_BE_EMPTY_VALIDATION_MESSAGE()),
    }),
    name: z.string().min(1, VM.CANT_BE_EMPTY_VALIDATION_MESSAGE()),
    phone: z.string().min(1, VM.CANT_BE_EMPTY_VALIDATION_MESSAGE()),
    email: z.string().email(VM.EMAIL_INVALID_VALIDATION_MESSAGE()),
    text: z.string().optional(),
    gdpr: z.boolean().refine(val => val === true, {
      message: VM.GDPR_VALIDATION_MESSAGE(),
    }),
    'g-recaptcha-response': z.string().default(''),
  });

export type DriveFormValues = z.infer<ReturnType<typeof driveSchema>>;
